
const NHDivider = (props) => {
    return <div className={`w-100 bg-neutral-cloud ${props?.extra_class}`} style={{height:"1px"}}></div>;
}

export default NHDivider;